import {
  ComponentTypeFactory,
  FieldTypeFactory,
} from '@sentecacommerce-theme/base'
import { BlogPageProps } from './blogPage.props'

export const BlogPageType = ComponentTypeFactory.create<BlogPageProps>('BlogPage', {
  categories: {
    title: FieldTypeFactory.text(),
    categoriesList: [
      {
        tag: FieldTypeFactory.text(),
        slug: FieldTypeFactory.text(),
        label: FieldTypeFactory.text(),
      },
    ],
  },
  labels: {
    title: FieldTypeFactory.text({ required: true }),
    readMore: FieldTypeFactory.text({ required: true }),
  },
  defaultMetaDescription: FieldTypeFactory.text(),
  isDev: FieldTypeFactory.boolean({ required: false }),
})
